import Repository from './Repository';

const resource = '/lessons';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    create(payload)     {return Repository.post(`${resource}`, payload);}
}